import React, { useState } from "react";
import { Avatar, Card } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { ModelBox } from "src/components";
import { htmlDecode } from "src/utils/convertHtml";
import { s3baseUrl } from "src/config/config";
import { timeAgo } from "src/utils/constants";
import {
  AddCommentAPI,
  DeleteComment,
  DeleteCommentImageOnS3,
  UpdateCommentAPI,
  UploadCommentImageOnS3,
} from "src/DAL/SupportTicket/Comments";
import { useSnackbar } from "notistack";
import CustomConfirmation from "src/components/GeneralComponents/CustomConfirmation";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
} from "src/assets";
import TinyEditor from "src/components/GeneralComponents/Ckeditor";
import CustomPopoverSection from "src/components/MenuOption/CustomPopoverSection";

function ChatCard({ comments, ticket_id, list_data, supportTicketData }) {
  const [open, setOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [files, setFiles] = useState([]);
  const [oldImagesArray, setOldImagesArray] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [commentId, setCommentId] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [shortDescriptionCk, setShortDescriptionCk] = useState("");
  const [showButtons, setShowButtons] = React.useState({
    addButton: true,
    editButton: false,
  });
  const handleOpen = (image_path) => {
    setImageUrl(image_path);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const handleRemove = (index) => {
    files.splice(index, 1);
    setFiles([...files]);
  };
  const handleUpload = (event) => {
    let setImageObject = {};
    const fileList = event.target.files;
    const arr = [];

    for (let i = 0; i < fileList.length; i++) {
      setImageObject = {
        path: fileList[i],
        type: "file",
        extension: fileList[i].type,
      };

      arr.push(setImageObject);
    }
    setFiles((prevFiles) => [...prevFiles, ...arr]);
  };

  const handleDelete = async () => {
    setOpenDelete(false);
    setIsLoading(true);
    const result = await DeleteComment(commentId);
    if (result.code === 200) {
      list_data();
      setIsLoading(false);
      enqueueSnackbar(result.message, { variant: "success" });
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  //Getting Note In textarea
  const handleEdit = (comment) => {
    setShortDescriptionCk(comment.message);
    setCommentId(comment._id);
    setShowButtons({
      addButton: false,
      editButton: true,
    });
    let setImageObject = {};
    comment.comment_image?.map((images, index) => {
      setImageObject = {
        thumbnail_1: images.thumbnail_1,
        thumbnail_2: images.thumbnail_2,
        type: "image",
      };
      files.push(setImageObject);
      oldImagesArray.push(setImageObject);
    });
  };

  const handleCancelUpdate = () => {
    setShortDescriptionCk("");
    setCommentId("");
    setShowButtons({
      addButton: true,
      editButton: false,
    });
    setFiles([]);
  };

  const handleAgreeDelete = (comment) => {
    setCommentId(comment._id);
    setOpenDelete(true);
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
      handleClick: handleEdit,
    },

    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];
  const MENU_OPTIONS1 = [
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleAgreeDelete,
    },
  ];

  const UploadImages = async (formData) => {
    const result = await UploadCommentImageOnS3(formData);
    return result.image_path;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const results = files.map((image, index) => {
      const formData = new FormData();
      formData.append("image", image.path);
      const result = UploadImages(formData);
      return result;
    });

    Promise.all(results).then(async (img_results) => {
      var setImageArray = [];
      img_results.map((image_path, index) => {
        setImageArray.push(image_path);
      });
      const formDataObject = {
        support_ticket: ticket_id,
        message: shortDescriptionCk,
      };
      if (files.length > 0) {
        formDataObject.comment_image = setImageArray;
      }
      const result = await AddCommentAPI(JSON.stringify(formDataObject));
      if (result.code === 200) {
        setIsLoading(false);
        list_data();
        setShortDescriptionCk("");
        setFiles([]);
        enqueueSnackbar(result.message, { variant: "success" });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    });
  };

  const DeleteImages = async (formData) => {
    const result = await DeleteCommentImageOnS3(formData);
    return result;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const deleted_images_array = [];
    let deleted_images_object = {};
    oldImagesArray.map((old_image, index) => {
      const filtered_array = files.filter(
        (image, index) => image.thumbnail_1 == old_image.thumbnail_1,
      );
      delete old_image.type;
      if (filtered_array.length == 0) {
        deleted_images_array.push(old_image);
      }
    });
    if (deleted_images_array.length > 0) {
      deleted_images_object = {
        moment_image: deleted_images_array,
      };
      const result = DeleteImages(deleted_images_object);
    }

    const results = files.map((image, index) => {
      if (image.type === "file") {
        const formData = new FormData();
        formData.append("image", image.path);
        const result = UploadImages(formData);
        return result;
      } else {
        return image;
      }
    });

    Promise.all(results).then(async (img_results) => {
      var setImageArray = [];
      img_results.map((image_path, index) => {
        setImageArray.push(image_path);
      });
      const formDataObject = {
        message: shortDescriptionCk,
      };
      if (files.length > 0) {
        formDataObject.comment_image = setImageArray;
      }
      const result = await UpdateCommentAPI(commentId, formDataObject);
      if (result.code === 200) {
        list_data();
        setShortDescriptionCk("");
        setFiles([]);
        setCommentId("");
        setShowButtons({
          addButton: true,
          editButton: false,
        });
        setIsLoading(false);
        enqueueSnackbar(result.message, { variant: "success" });
      } else {
        enqueueSnackbar(result.message, { variant: "error" });
        setIsLoading(false);
      }
    });
  };

  const imageLinks = {
    docx: wordImage,
    mp3: audioImage,
    pdf: pdfImage,
    csv: csvImage,
    doc: docImage,
    xlsx: xlsxImage,
    xls: xlsxImage,
    other: otherImage,
  };

  const getCommentRecourse = (file) => {
    const ext = file.thumbnail_1.split(".").pop();
    if (
      ext == "jpg" ||
      ext == "JPG" ||
      ext == "png" ||
      ext == "webp" ||
      ext == "jpeg" ||
      ext == "JPEG" ||
      ext == "PNG"
    ) {
      return s3baseUrl + file.thumbnail_1;
    } else if (imageLinks[ext]) {
      return imageLinks[ext];
    } else {
      return imageLinks.other;
    }
  };

  const getCommentImage = (file) => {
    if (file.type === "file") {
      const ext = file.path.name.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return URL.createObjectURL(file.path);
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    } else {
      const ext = file.thumbnail_1.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return s3baseUrl + file.thumbnail_1;
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    }
  };

  return (
    <div className="col-12">
      <Card className="chat-main-card p-2 mt-3">
        <div className="chat-message-box">
          {comments &&
            comments.map((comment, i) => {
              const comment_date = timeAgo(comment.action_date);
              return (
                <>
                  <div className="incoming-message w-100 ps-2 pe-3">
                    <div className="chat-message-body pt-1 pb-4 mt-2">
                      <div className="d-flex ">
                        <div className="circle-image circle-image-chat">
                          {comment.action_user_info.profile_image ? (
                            <img
                              src={
                                s3baseUrl +
                                comment.action_user_info.profile_image
                              }
                            />
                          ) : (
                            <Avatar
                              alt={comment?.action_user_info?.action_name}
                              src={
                                s3baseUrl +
                                comment.action_user_info.profile_image
                              }
                              sx={{ marginRight: 1, marginLeft: 1 }}
                            />
                          )}
                        </div>
                        <div className="description w-100 custom-popover-box">
                          <div className="set-title-width d-flex justify-content-between w-100 pe-3">
                            <p className="card-title pt-2 mb-0">
                              {htmlDecode(comment.action_user_info.action_name)}
                            </p>
                            <div className="d-flex">
                              <p className="date-color me-2 mb-0">
                                {comment_date}
                              </p>
                              {comment.action_user_info.action_by ===
                              "member_user" ? (
                                supportTicketData.ticket_status === 0 ? (
                                  <CustomPopoverSection
                                    menu={MENU_OPTIONS}
                                    data={comment}
                                  />
                                ) : (
                                  ""
                                )
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div
                            className="mt-3"
                            dangerouslySetInnerHTML={{
                              __html: comment.message,
                            }}
                          ></div>
                          {comment.comment_image &&
                            comment.comment_image.map((image, i) => {
                              const ext = image.thumbnail_1.split(".").pop();
                              if (
                                ext == "jpg" ||
                                ext == "JPG" ||
                                ext == "png" ||
                                ext == "webp" ||
                                ext == "jpeg" ||
                                ext == "JPEG" ||
                                ext == "PNG"
                              ) {
                                return (
                                  <span className="preview" key={i}>
                                    <img
                                      onClick={() => {
                                        handleOpen(
                                          s3baseUrl + image.thumbnail_1,
                                        );
                                      }}
                                      className="p-0"
                                      src={s3baseUrl + image.thumbnail_1}
                                    />
                                  </span>
                                );
                              } else {
                                return (
                                  <span className="preview" key={i}>
                                    <a
                                      href={s3baseUrl + image.thumbnail_1}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      <img src={getCommentRecourse(image)} />
                                    </a>
                                  </span>
                                );
                              }
                            })}
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr />
                </>
              );
            })}
          <form onSubmit={showButtons.addButton ? handleSubmit : handleUpdate}>
            <div className="col-12 mt-4">
              <h4>Enter Message* </h4>
              <TinyEditor
                setDetailDescription={setShortDescriptionCk}
                detailDescriptionCk={shortDescriptionCk}
              />
            </div>
            <div className="w-100 px-3 d-flex">
              <div className="row w-100 mb-3 add-photo">
                <p className="mt-3 mb-0">Recommended Size (1000x670)</p>
                {files &&
                  files.map((file, index) => (
                    <div
                      className="col-sm-3 col-md-2 col-lg-1 mt-2 ms-2 p-0"
                      key={index}
                    >
                      <span className="preview">
                        <span onClick={() => handleRemove(index)}>x</span>
                        <img src={getCommentImage(file)} />
                      </span>
                    </div>
                  ))}
                <div className="col-sm-3 col-md-2 col-lg-1 mt-2">
                  <span className="upload-button">
                    <input
                      color="primary"
                      type="file"
                      id="icon-button-file"
                      style={{ display: "none" }}
                      onChange={handleUpload}
                      multiple={true}
                      accept="image/*,.pdf,.xlsx,.xls,.docx,.csv,.doc"
                    />
                    <label htmlFor="icon-button-file">
                      <CloudUploadIcon />
                    </label>
                  </span>
                </div>
              </div>
            </div>
            {showButtons.addButton === true &&
              (supportTicketData.ticket_status === 0 ? (
                <button
                  type="submit"
                  className="mt-2 float-end small-contained-button mb-4"
                  disabled={isLoading}
                >
                  {isLoading ? "Saving..." : "Send"}
                </button>
              ) : (
                <button
                  type="submit"
                  className="mt-2 float-end small-contained-button disabled mb-4"
                  disabled={true}
                >
                  Send
                </button>
              ))}
            {showButtons.editButton === true && (
              <div className="d-flex justify-content-end mb-4 me-4">
                <button
                  className="mt-2 me-2 small-contained-button"
                  onClick={handleCancelUpdate}
                >
                  Cancel
                </button>
                <button
                  className="mt-2 small-contained-button"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? "Updating..." : "Update"}
                </button>
              </div>
            )}
            <CustomConfirmation
              open={openDelete}
              setOpen={setOpenDelete}
              title={"Are you sure you want to delete this comment?"}
              handleAgree={handleDelete}
            />
          </form>
        </div>
      </Card>
      <ModelBox open={open} handleClose={handleClose} image_url={imageUrl} />
    </div>
  );
}

export default ChatCard;
